import { Box, Grid2, Typography } from "@mui/material"
import { getDatePickerDate } from "../../../../../Helper/DatePicker/DateConverter"
import CustomCalendar from "../../../../../Components/CustomCalendar"


const DateCalenderFilter = ({ filter, newFilters, onChange, rangePresets = undefined }) => {
    let currentFilter = newFilters[filter.key]
    let dates = [getDatePickerDate(undefined, -14), getDatePickerDate()]

    if (currentFilter && currentFilter[0]) {
        let { startDate, endDate } = JSON.parse(currentFilter[0])
        dates = [startDate, endDate]
    }

    return (
        <Grid2 container flexDirection={'column'}>
            <Box>
                <Typography variant="fw500s12lh24c5E758D" sx={{ mb: 0.5 }}>Select date range</Typography>
            </Box>
            <Box>
                <CustomCalendar
                    changeTheDate={(startDate, endDate) => { onChange(filter.key, { startDate, endDate }) }}
                    date={dates}
                    allowClear={true}
                    rangePresets={rangePresets}
                />
            </Box>
        </Grid2>
    )
}

export default DateCalenderFilter;
